const $cursor = document.querySelector('.cursor');
const $bigBall = document.querySelector('.cursor__ball--big');
const $smallBall = document.querySelector('.cursor__ball--small');
const SCROLL_CURSOR_HEADING = 'EVERY DETAIL IS DESIGNED AROUND YOU';
const DEFAULT_CURSOR_MODE_THRESHOLD = 0.05;
let activePortfolioCursorState = '';

if ($smallBall && !$smallBall.querySelector('.cursor__icon')) {
  $smallBall.insertAdjacentHTML('beforeend', '<span class="cursor__icon" aria-hidden="true"></span>');
}

if ($cursor && !$cursor.querySelector('.cursor__scroll-pill')) {
  $cursor.insertAdjacentHTML(
    'beforeend',
    [
      '<div class="cursor__scroll-pill" aria-hidden="true">',
      '  <div class="cursor__scroll-pill-shell">',
      '    <span class="cursor__scroll-pill-icon">',
      '      <svg viewBox="0 0 72 72" role="presentation" focusable="false">',
      '        <path class="cursor__scroll-pill-stem" d="M36 13v28" />',
      '        <path class="cursor__scroll-pill-arc-left" d="M19 29c6 0 11 5 17 14" />',
      '        <path class="cursor__scroll-pill-arc-right" d="M53 29c-6 0-11 5-17 14" />',
      '        <path class="cursor__scroll-pill-tip" d="M29 41l7 7 7-7" />',
      '      </svg>',
      '    </span>',
      '    <span class="cursor__scroll-pill-label">Scroll</span>',
      '  </div>',
      '</div>'
    ].join('')
  );
}

const $scrollPill = document.querySelector('.cursor__scroll-pill');
const cursorModeAreas = Array.from(document.querySelectorAll('[data-cursor-mode]'));

document.querySelectorAll('.sr-scroll__heading').forEach(function(heading) {
  if ((heading.textContent || '').trim().toUpperCase() !== SCROLL_CURSOR_HEADING) return;

  const area = heading.closest('.sr-scroll');
  if (!area) return;

  if (!area.dataset.cursorMode) {
    area.dataset.cursorMode = 'scroll-pill';
  }

  if (!cursorModeAreas.includes(area)) {
    cursorModeAreas.push(area);
  }
});

let isHoveringInteractive = false;
let activeCursorMode = '';
let hoveredCursorArea = null;

// ---- RAF-batched cursor movement (max one GSAP tween per frame) ----
let mouseX = -200, mouseY = -200;
let rafScheduled = false;

function setCursorMode(mode) {
  activeCursorMode = mode || '';

  if (!$cursor) return;

  const isScrollPill = activeCursorMode === 'scroll-pill';
  $cursor.classList.toggle('cursor--scroll-pill', isScrollPill);

  if (isScrollPill && $bigBall && typeof gsap !== 'undefined') {
    gsap.set($bigBall, { scale: 1, overwrite: 'auto' });
  }
}

function setPortfolioCursorState(mode) {
  activePortfolioCursorState = mode === 'open' || mode === 'close' ? mode : '';

  if (!$cursor || !$bigBall || !$smallBall || typeof gsap === 'undefined') return;

  $cursor.classList.toggle('cursor--portfolio-open', activePortfolioCursorState === 'open');
  $cursor.classList.toggle('cursor--portfolio-close', activePortfolioCursorState === 'close');

  if (activePortfolioCursorState) {
    gsap.to($bigBall, { duration: 0.24, scale: 1.35, overwrite: 'auto' });
    gsap.to($smallBall, { duration: 0.24, scale: 1, overwrite: 'auto' });
    return;
  }

  if (activeCursorMode === 'scroll-pill') {
    gsap.to($bigBall, { duration: 0.24, scale: 1, overwrite: 'auto' });
    gsap.to($smallBall, { duration: 0.24, scale: 1, overwrite: 'auto' });
    return;
  }

  if (hasActiveZoomTarget()) return;
  gsap.to($bigBall, { duration: 0.24, scale: isHoveringInteractive ? 4 : 1, overwrite: 'auto' });
  gsap.to($smallBall, { duration: 0.24, scale: 1, overwrite: 'auto' });
}

window.setPortfolioCursorState = setPortfolioCursorState;

function clamp01(value) {
  if (value < 0) return 0;
  if (value > 1) return 1;
  return value;
}

function getAreaProgress(area) {
  if (!area) return 0;

  const rect = area.getBoundingClientRect();
  const total = area.offsetHeight - window.innerHeight;

  if (total <= 0) {
    return rect.top <= 0 && rect.bottom >= window.innerHeight ? 1 : 0;
  }

  return clamp01(-rect.top / total);
}

function syncAreaCursorMode() {
  if (!hoveredCursorArea) {
    if (activeCursorMode === 'scroll-pill') {
      setCursorMode('');
    }
    return;
  }

  const threshold = Number(hoveredCursorArea.dataset.cursorThreshold || DEFAULT_CURSOR_MODE_THRESHOLD);
  const progress = getAreaProgress(hoveredCursorArea);

  if (progress >= threshold) {
    setCursorMode(hoveredCursorArea.dataset.cursorMode);
  } else if (activeCursorMode === hoveredCursorArea.dataset.cursorMode) {
    setCursorMode('');
  }
}

cursorModeAreas.forEach(function(area) {
  area.addEventListener('mouseenter', function() {
    hoveredCursorArea = area;
    syncAreaCursorMode();
  });

  area.addEventListener('mouseleave', function() {
    if (hoveredCursorArea === area) {
      hoveredCursorArea = null;
    }
    setCursorMode('');
  });
});

function scheduleCursorUpdate() {
  if (rafScheduled) return;
  rafScheduled = true;
  requestAnimationFrame(function() {
    rafScheduled = false;
    var smallBallOffset = activePortfolioCursorState ? 15 : 5;
    gsap.to($bigBall,  { duration: 0.4, x: mouseX - 15, y: mouseY - 15, overwrite: 'auto' });
    gsap.to($smallBall, { duration: 0.1, x: mouseX - smallBallOffset,  y: mouseY - smallBallOffset,  overwrite: 'auto' });
    if ($scrollPill) {
      var pillW = $scrollPill.offsetWidth;
      var pillH = $scrollPill.offsetHeight;
      gsap.to($scrollPill, { duration: 0.22, x: mouseX - pillW / 2, y: mouseY - pillH / 2, overwrite: 'auto' });
    }
  });
}

// ---- Hide custom cursor in cart drawer — show native Windows cursor instead ----
function syncCartCursor() {
  const isCartOpen = !!document.querySelector('dialog.cart-drawer__dialog[open]');
  if ($cursor) $cursor.style.display = isCartOpen ? 'none' : '';
}

const dialogObserver = new MutationObserver(syncCartCursor);
dialogObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
syncCartCursor();

// Seletor universal para todos os elementos clicáveis
const hoverSelector = `
  a, 
  button, 
  .button,
  .hoverable,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  [role="button"],
  [onclick],
  summary,
  details,
  .modal-toggle,
  .drawer-toggle,
  .menu-toggle,
  select,
  label[for],
  .product-card,
  .card,
  .slider-button,
  .carousel-control,
  .nav-link,
  .tab,
  .accordion-toggle,
  .modal-close,
  .popup-close,
  .icon-button,
  .menu-item,
  .dropdown-toggle,
  .slider,
  .carousel,
  .draggable,
  [draggable="true"],
  .product-card-wrapper,
  .card-wrapper,
  .media,
  .image-with-text,
  .banner,
  .slide,
  .quick-add-button,
  .quantity-button,
  .swatch,
  .color-swatch,
  .variant-picker,
  .localization-form,
  .header__icon,
  .drawer__close,
  .predictive-search__item,
  .pagination a,
  .facet-checkbox,
  .mobile-facets__checkbox,
  .filter-chip,
  .sort-by,
  .collection-filters,
  .product-form__submit,
  .shopify-payment-button,
  .cart-item__remove,
  .cart-drawer__close,
  .gift-card-recipient-checkbox,
  .disclosure-has-popup,
  .header__menu-item,
  .list-menu__item,
  .footer__list-item,
  .spec-dot,
  .showcase-dot,
  .showcase-label,
  .spec-label,
  .ts2-mnav-item,
  .ts2-dot,
  .ts2-label,
  .ts2b-dot,
  .ts2b-mnav-item,
  .ts2b-label,
  #cw-host .cw-fab,
  #cw-host .cw-card
`.trim();

function getInteractiveTarget(node) {
  if (!(node instanceof Element)) return null;
  if (node.closest('.footer-section-grid .menu__heading')) return null;
  if (node.matches(hoverSelector)) return node;
  return node.closest(hoverSelector);
}

function hasActiveZoomTarget() {
  return typeof activeZoomTarget !== 'undefined' && !!activeZoomTarget;
}

if ($cursor && $cursor.parentNode !== document.documentElement) {
  document.documentElement.appendChild($cursor);
}

if ($bigBall && $smallBall && typeof gsap !== 'undefined') {
  document.addEventListener('mousemove', function(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    scheduleCursorUpdate();
  });

  document.addEventListener('mouseleave', function() {
    hoveredCursorArea = null;
    setCursorMode('');
  });

  window.addEventListener('scroll', function() {
    syncAreaCursorMode();
  }, { passive: true });

  window.addEventListener('resize', function() {
    syncAreaCursorMode();
  });

  // Usa delegação de eventos para capturar hovers em elementos dinâmicos
  document.addEventListener('mouseover', function(e) {
    if (activePortfolioCursorState) return;

    if (activeCursorMode === 'scroll-pill') {
      if (hoveredCursorArea && !hoveredCursorArea.contains(e.target)) {
        // Cursor saiu da área scroll-pill (ex: header fixo) — limpa modo e detecta interativo
        setCursorMode('');
        // fall through para detecção de elementos interativos abaixo
      } else {
        return; // ainda dentro da área scroll-pill
      }
    } else if (hoveredCursorArea && hoveredCursorArea.contains(e.target)) {
      // Cursor voltou para a área cursor-mode (ex: do header de volta ao hero)
      syncAreaCursorMode();
      return;
    }

    var interactiveTarget = getInteractiveTarget(e.target);
    if (!interactiveTarget) return;

    var relatedTarget = getInteractiveTarget(e.relatedTarget);
    if (relatedTarget === interactiveTarget) return;

    isHoveringInteractive = true;
    if (hasActiveZoomTarget()) return;
    gsap.to($bigBall, { duration: 0.3, scale: 4, overwrite: 'auto' });
  });

  document.addEventListener('mouseout', function(e) {
    if (activePortfolioCursorState) return;
    if (activeCursorMode === 'scroll-pill') {
      if (!hoveredCursorArea || hoveredCursorArea.contains(e.target)) return;
      // Saindo de elemento fora da área scroll-pill — permite redução do cursor
    }

    var interactiveTarget = getInteractiveTarget(e.target);
    if (!interactiveTarget) return;

    var relatedTarget = getInteractiveTarget(e.relatedTarget);
    if (relatedTarget === interactiveTarget) return;

    isHoveringInteractive = false;
    if (hasActiveZoomTarget()) return;
    gsap.to($bigBall, { duration: 0.3, scale: 1, overwrite: 'auto' });
  });
}
